"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _MaterialComponent = _interopRequireDefault(require("../MaterialComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @prop mini = false
 * @prop plain = false
 */
class Elevation extends _MaterialComponent.default {
  constructor() {
    super();
    this.componentName = 'elevation';
    this._mdcProps = [];

    for (let elevationIndex = 0; elevationIndex < 25; elevationIndex++) {
      this._mdcProps.push('z' + elevationIndex);
    }
  }

  materialDom(props) {
    let className = '';

    if (props.z) {
      className = 'mdc-elevation--z' + props.z;
    }

    return (0, _preact.h)("p", _extends({
      className: className
    }, props, {
      ref: this.setControlRef
    }), props.children);
  }

}

exports.default = Elevation;


// WEBPACK FOOTER //
// ../node_modules/preact-material-components/Elevation/index.js